import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppBrowserModule } from './app/app.module';
import { environment } from './environments/environment';

declare function splunkRumInit(
  splunkScriptUrl: string,
  splunkRecorderScriptUrl: string,
  splunkAccessToken: string,
  splunkAppName: string,
  splunkDeploymentEnvironment: string
): void;

function initializeSplunkBeforeBootstrap(): Promise<void> {
  return new Promise((resolve) => {
    if (environment.splunkDeploymentEnvironment == 'local') {
      resolve();
      return;
    }

    if (typeof window === 'undefined' || typeof document === 'undefined' || (window as any).__splunkPreInitialized) {
      resolve();
      return;
    }

    try {
      const script = document.createElement('script');
      script.src = '/assets/splunk/splunk-rum-dev.js';
      script.async = false;
      script.onload = () => {
        try {
          splunkRumInit(
            environment.splunkScriptUrl,
            environment.splunkRecorderScriptUrl,
            environment.splunkRumAccessToken,
            environment.splunkAppName,
            environment.splunkDeploymentEnvironment
          );
          (window as any).__splunkPreInitialized = true;
          resolve();
        } catch (error) {
          resolve();
        }
      };
      script.onerror = () => {
        resolve();
      };

      document.head.appendChild(script);
    } catch (error) {
      resolve();
    }
  });
}

const redirect = () => {
  const currentUrl = window.location.href;
  const redirectUrl = currentUrl.replace(environment.oldAppURL, environment.appBaseUrl);
  if (window.location.origin === environment.oldAppURL) {
    window.location.replace(redirectUrl);
  }
};

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (const registration of registrations) {
      if (registration.active && registration.active.scriptURL === `${environment.oldAppURL}/ngsw-worker.js`) {
        registration.unregister().then(() => {
          redirect();
        });
      }
    }
  });
}
redirect();

if (environment.production) {
  enableProdMode();
}

initializeSplunkBeforeBootstrap()
  .then(() => {
    return platformBrowserDynamic().bootstrapModule(AppBrowserModule, {
      applicationProviders: [provideZoneChangeDetection()],
    });
  })
  .catch(() => {
    return platformBrowserDynamic().bootstrapModule(AppBrowserModule, {
      applicationProviders: [provideZoneChangeDetection()],
    });
  });
